var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginStatus)?_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("Beenden\n    "),_c('span',{staticClass:"sr-only"},[_vm._v("(current)")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }